(function () {
  function enableGridScroll(section) {
    if (!section || section.dataset.hasFeatured !== 'false') return;

    const grid = section.querySelector('.bh__grid');
    if (!grid || grid.dataset.scrollReady === 'true') return;

    grid.dataset.scrollReady = 'true';

    let isDragging = false;
    let hasDragged = false;
    let startX = 0;
    let startScrollLeft = 0;

    grid.addEventListener(
      'wheel',
      function (event) {
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        event.preventDefault();
        grid.scrollBy({ left: event.deltaY, behavior: 'auto' });
      },
      { passive: false }
    );

    grid.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      isDragging = true;
      hasDragged = false;
      startX = event.clientX;
      startScrollLeft = grid.scrollLeft;
      grid.classList.add('is-dragging');

      if (grid.setPointerCapture) {
        grid.setPointerCapture(event.pointerId);
      }
    });

    grid.addEventListener('pointermove', function (event) {
      if (!isDragging) return;

      const deltaX = event.clientX - startX;
      if (Math.abs(deltaX) > 4) hasDragged = true;
      grid.scrollLeft = startScrollLeft - deltaX;
    });

    function stopDragging() {
      isDragging = false;
      grid.classList.remove('is-dragging');
    }

    grid.addEventListener('pointerup', stopDragging);
    grid.addEventListener('pointercancel', stopDragging);
    grid.addEventListener('pointerleave', stopDragging);

    grid.addEventListener(
      'click',
      function (event) {
        if (!hasDragged) return;

        event.preventDefault();
        event.stopPropagation();
        hasDragged = false;
      },
      true
    );
  }

  function init() {
    const sections = document.querySelectorAll('[id^="BlogHub-"]');
    sections.forEach(enableGridScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();